import { Avatar, Box } from '@chakra-ui/react';
// import { KText } from '../../text';
import { useState } from 'react';

export const KImage = ({
  src = undefined,
  name = undefined,
  size = '18px',
  backgroundStyles = {},
  textStyles = {},
}: {
  src?: string;
  name?: string;
  size?: string;
  backgroundStyles?: Record<string, any>;
  textStyles?: Record<string, any>;
}) => {
  const [imageFailed, setImageFailed] = useState(false);

  // const numericSize = parseInt(size, 10);
  // const fontSize = `${Math.min(numericSize * 0.45, numericSize / 2, 24)}px`;

  const handleImageError = () => {
    setImageFailed(true); // Set flag when image fails
  };

  return (
    <Box
      width={size}
      height={size}
      borderRadius="3px"
      overflow="hidden"
      bg={src && !imageFailed ? 'transparent' : 'secondary-100'}
      alignItems="center"
      justifyContent="center"
      position="relative"
      {...backgroundStyles}
    >
      {src && !imageFailed ? (
        <img
          src={src}
          alt={name || 'Avatar'}
          loading="lazy"
          onError={handleImageError} // Trigger fallback on error
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            transition: 'opacity 0.3s ease-in-out',
          }}
        />
      ) : (
        <Avatar
          name={name}
          width={size}
          height={size}
          borderRadius="6px"
          className="avatar-xs"
        />
        // fall back to our own font style
        // <KText
        //   fontSize={fontSize}
        //   fontWeight="bold"
        //   letterSpacing="1px"
        //   color="primary-500"
        //   textAlign="center"
        //   {...textStyles}
        // >
        //   {name
        //     .trim()
        //     .split(' ')
        //     .map((part) => part.charAt(0).toUpperCase())
        //     .slice(0, 2)
        //     .join('') || ''}
        // </KText>
      )}
    </Box>
  );
};
